<template>
  <b-container
    class="bv-example-row"
    fluid
  >
    <b-row align-h="end">
      <b-button
        variant="success"
        @click="save"
      >
        บันทึก
      </b-button>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <table class="table table-striped table-bordered table-responsive">
        <thead>
          <tr>
            <th
              v-for="(field) in fields"
              :key="field.key"
            >
              {{ field.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in items">
            <tr
              :key="index+item[0]"
              class="col-left"
            >
              <td>
                <b>{{ item[0] }}</b>
              </td>
              <td
                v-for="(field) in permissionFields"
                :key="field.key"
              />
            </tr>
            <tr
              v-for="(permission, index) in item[1]"
              :key="index+item[0]"
            >
              <td class="col-left">
                {{ index }}
              </td>
              <td
                v-for="(field) in permissionFields"
                :key="field.key"
              >
                <b-checkbox
                  v-model="item[1][index][field.label].value"
                  :checked="permission[field.label].value"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </b-row>
  </b-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: "PermissionView",
    computed: {
      ...mapGetters({

      })
    },
    data() {
      return {
        items: [],
        oldItems: [],
        fields: [
          {
            label: 'PERMISSION',
            key: 'permission'
          }
        ],
        permissionFields: []
      }
    },
    methods: {
      ...mapActions({
        getPermissionList: 'Settings/getPermissionList',
        setPermission: 'Settings/setUserGroupList'
      }),
      async save() {
        let newValue = [];
        let serverPermission = await this.getServerPermission()
        this.items.forEach((title, titleIndex) => {
          Object.keys(title[1]).map((permission) => {
            Object.keys(title[1][permission]).map((role) => {
              if (title[1][permission][role].value !== serverPermission[titleIndex][1][permission][role].value) {
                let val = title[1][permission][role]
                if (!newValue[val.id]) {
                  newValue[val.id] = {}
                }
                newValue[val.id][val.key] = val.value
              }
            })
          })
        })

        await newValue.forEach(async (el, index)=> {
          let res = await this.setPermission({id: index, payload: {permission_json: el}})

          if (res) {
            this.$swal.fire("บันทึกสำเร็จ.")
          }

        })

      },
      async getServerPermission() {
        let permissionList = await this.getPermissionList()

        return Object.keys(permissionList).map(function (key) {
          return [(key), permissionList[key]];
        })
      }
    },
    async created() {
      let res = await this.$store.dispatch('Settings/getUserGroupList')

      res.forEach(el => {
        this.permissionFields.push({
          label: `${el.name}`,
          key: `${el.id}`
        })
      })

      this.fields = [ ...this.fields, ...this.permissionFields]
    },
    async mounted() {
        this.items = await this.getServerPermission()
    }
  }
</script>

<style scoped>

</style>
